// @flow
import type {MockEdge} from './mockEdge';

const iconMarkdoc = (alt: string): string =>
  alt ? `\n{% icon type="webhook" alt="${alt}" /%}` : '';
// Generates {% edge %} Markdoc text for a user to copy and paste
export const edgeMarkdoc = (edge: MockEdge): string => {
  const {attributes, children} = edge;
  const {from, to} = attributes;

  let label = '';
  let icon = '';
  if (children?.length) {
    label = children.find((c) => c.name === 'Paragraph')?.children[0] || '';
    icon = children.find((c) => c.name === 'Icon')?.attributes.alt || '';
  }
  if (label) {
    return `{% edge from="${from}" to="${to}" %}\n${label}${iconMarkdoc(
      icon,
    )}\n{% /edge %}`;
  }
  return `{% edge from="${from}" to="${to}" /%}`;
};
